import { ArrowRight, MessageCircle, Sparkles } from "lucide-react";
import { useStart } from "./useStart";

const PhoneMock = () => (
  <div className="relative mx-auto w-[300px] sm:w-[330px] floaty">
    <div className="absolute -inset-8 brand-gradient opacity-30 blur-3xl rounded-full" />
    <div className="relative rounded-[2.5rem] border border-border bg-card p-4 shadow-2xl">
      <div className="flex items-center gap-3 pb-3 border-b border-border">
        <div className="h-9 w-9 rounded-full bg-gradient-to-br from-amber-300 to-pink-400" />
        <div>
          <div className="text-sm font-semibold">Riya</div>
          <div className="text-[11px] text-muted-foreground">fictional chat</div>
        </div>
      </div>
      <div className="space-y-2 py-4 text-sm">
        <div className="bubble-them rounded-2xl rounded-bl-sm px-3 py-2 max-w-[80%]">ok but who puts pineapple on pizza</div>
        <div className="ml-auto bg-primary text-primary-foreground rounded-2xl rounded-br-sm px-3 py-2 max-w-[80%] w-fit">guilty 🍍</div>
        <div className="bubble-them rounded-2xl rounded-bl-sm px-3 py-2 max-w-[80%]">You always have something funny to say 😂</div>
      </div>
      <div className="rounded-2xl border border-primary/30 bg-secondary/60 p-3 space-y-2">
        <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-primary">
          <Sparkles className="h-3 w-3" /> Example suggestions
        </div>
        {["Maybe you're just giving me good material 😂", "Only because you make the conversation interesting 😉"].map((t, i) => (
          <div key={t} className="rise rounded-xl bg-card border border-border px-3 py-2 text-[13px]" style={{ animationDelay: `${0.4 + i * 0.25}s` }}>{t}</div>
        ))}
      </div>
    </div>
  </div>
);

export const Hero = () => {
  const start = useStart();
  return (
    <section className="relative grid-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-20 grid lg:grid-cols-[1.15fr_1fr] gap-14 items-center">
        <div className="space-y-8">
          <span className="rise inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1 text-xs font-medium">
            <MessageCircle className="h-3.5 w-3.5 text-accent" /> Works with WhatsApp, Instagram, Tinder, Bumble & more
          </span>
          <h1 className="rise text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]" style={{ animationDelay: "0.08s" }}>
            Your Next <span className="brand-text">Flirty Reply</span> Starts Here.
          </h1>
          <p className="rise text-base sm:text-lg text-muted-foreground max-w-xl" style={{ animationDelay: "0.16s" }}>
            Drop in a chat screenshot or paste the text. AI reads the vibe and suggests three natural, witty, confident and playful replies in English, Hinglish or Hindi — you pick, copy and send.
          </p>
          <div className="rise flex flex-col sm:flex-row gap-3" style={{ animationDelay: "0.24s" }}>
            <button data-testid="landing-generate-reply-cta" onClick={() => start()} className="group py-3.5 px-7 rounded-full brand-gradient text-white font-semibold inline-flex items-center justify-center gap-2 shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40 transition-shadow">
              Generate My Reply <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
            <a href="#demo" data-testid="landing-try-sample-cta" className="py-3.5 px-7 rounded-full border border-border bg-card font-semibold inline-flex items-center justify-center hover:border-primary/50 transition-colors">
              Try a Sample Chat
            </a>
          </div>
          <p className="text-xs text-muted-foreground">Suggestions only. Nothing is ever sent for you.</p>
        </div>
        <PhoneMock />
      </div>
    </section>
  );
};
